import React, {Component} from 'react';
import Button from './Button';
import styled, {withTheme} from 'styled-components/macro'

const Icon = styled.svg`
  width: 32px;
  height: 32px;
  margin: 8px;
  fill: ${({theme}) => theme.bg};
`

const White = styled.div`
  border-radius: 24px;
  border: 2px solid ${({theme}) => theme.bg};
  width: 40px;
  height: 40px;
  margin: 4px;
  background-color: white;
`

const Black = styled.div`
  border-radius: 24px;
  border: 2px solid ${({theme}) => theme.bg};
  width: 40px;
  height: 40px;
  margin: 4px;
  background-color: black;
`

class Color extends Component {

  constructor(props){
    super(props);
    this.state = { open: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    this.setState(state => {
      return {
        open: !state.open
      }
    })
  }


  render(){
    let {open} = this.state;
    let {toogleColor, theme} = this.props;
    return (
      <Button open={open} onClick={this.handleClick}>
        {
          open ? (
            theme.name === 'white' ?
            <>
              <Black onClick={()=>{toogleColor("black")}}/>
              <White onClick={()=>{toogleColor("white")}}/>
            </> : <>
              <White onClick={()=>{toogleColor("white")}}/>
              <Black onClick={()=>{toogleColor("black")}}/>
            </>
          ):
          <Icon viewBox="0 0 24 24">
            <path d="M16.6,12.4L7.6,3.5L6.2,4.9l2.4,2.4l-5.2,5.2c-0.6,0.6-0.6,1.5,0,2.1l5.5,5.5c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4 l5.5-5.5C17.2,14,17.2,13,16.6,12.4z M5.2,13.5L10,8.7l4.8,4.8H5.2z M19,15c0,0-2,2.2-2,3.5c0,1.1,0.9,2,2,2s2-0.9,2-2 C21,17.2,19,15,19,15z"/>
          </Icon>
        }
      </Button>
    )
  }
}

export default withTheme(Color);